var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import Seatmap from './Seatmap';
var SeatPickerImp = /** @class */ (function (_super) {
    __extends(SeatPickerImp, _super);
    function SeatPickerImp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false
        };
        _this.addSeatCallback = function (_a, addCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            _this.setState({
                loading: true
            }, function () { return __awaiter(_this, void 0, void 0, function () {
                var newTooltip;
                return __generator(this, function (_a) {
                    console.log("Added seat ".concat(numero, ", row ").concat(row, ", id ").concat(id));
                    newTooltip = "tooltip for id-".concat(id, " added by callback");
                    addCb(row, numero, id, newTooltip);
                    this.setState({ loading: false });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.addSeatCallbackContinousCase = function (_a, addCb, params, removeCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            _this.setState({
                loading: true
            }, function () { return __awaiter(_this, void 0, void 0, function () {
                var newTooltip;
                return __generator(this, function (_a) {
                    if (removeCb) {
                        console.log("Removed seat ".concat(params.numero, ", row ").concat(params.row, ", id ").concat(params.id));
                        removeCb(params.row, params.numero);
                    }
                    console.log("Added seat ".concat(numero, ", row ").concat(row, ", id ").concat(id));
                    newTooltip = "tooltip for id-".concat(id, " added by callback");
                    addCb(row, numero, id, newTooltip);
                    this.setState({ loading: false });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.removeSeatCallback = function (_a, removeCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            _this.setState({
                loading: true
            }, function () { return __awaiter(_this, void 0, void 0, function () {
                var newTooltip;
                return __generator(this, function (_a) {
                    console.log("Removed seat ".concat(numero, ", row ").concat(row, ", id ").concat(id));
                    newTooltip = ['A', 'B', 'C'].includes(row) ? null : '';
                    removeCb(row, numero, newTooltip);
                    this.setState({ loading: false });
                    return [2 /*return*/];
                });
            }); });
        };
        return _this;
    }
    SeatPickerImp.prototype.render = function () {
        var anfiteatro = [
            [
                { id: 1, numero: 'a', offset: 0, onlyHandicapped: true },
                { id: 2, numero: 'b' },
                null,
                { id: 3, numero: '3', isReserved: true, offset: 0 },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 6, numero: 6 },
                { id: 7, numero: 7, isReserved: true },
                { id: 8, numero: 8, isReserved: true },
                { id: 9, numero: '9', isReserved: true },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                { id: 12, numero: 12 }
            ],
            [
                { id: 13, numero: 1 },
                { id: 14, numero: 2 },
                null,
                { id: 15, numero: 3, isReserved: true, offset: 0 },
                { id: 16, numero: '4' },
                null,
                { id: 17, numero: 5 },
                { id: 18, numero: 6 }
            ],
            [
                { id: 19, numero: 1 },
                { id: 20, numero: 2 },
                null,
                { id: 21, numero: 3, },
                { id: 22, numero: '4' },
                null,
                { id: 23, numero: 5 },
                { id: 24, numero: 6 }
            ],
            [
                { id: 25, numero: 1, isReserved: true },
                { id: 26, numero: 2 },
                null,
                { id: 27, numero: '3', isReserved: true },
                { id: 28, numero: '4' },
                null,
                { id: 29, numero: 5, tooltip: 'Cost: 11$' },
                { id: 30, numero: 6, isReserved: true }
            ]
        ];
        var patio = [
            [
                null,
                { id: 1, numero: 1, tooltip: 'F1:B1' },
                { id: 2, numero: 2, tooltip: 'F1:B2' },
                { id: 3, numero: '3', tooltip: 'F1:B3', asiento: 'F1:B3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 6, numero: 6 },
                { id: 7, numero: 7 },
                { id: 8, numero: 8 },
                null,
                null,
                null,
                { id: 9, numero: 7, offset: 0 },
                { id: 10, numero: 8, },
                { id: 11, numero: '9' },
                { id: 12, numero: '10' },
                { id: 13, numero: 11 },
                { id: 14, numero: 12 },
                { id: 15, numero: 13 },
                { id: 16, numero: 14 },
            ],
            [
                null,
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 6, numero: 6 },
                { id: 7, numero: 7 },
                { id: 8, numero: 8 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 0 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                { id: 12, numero: 12 },
                { id: 13, numero: 13 },
                { id: 14, numero: 14 },
            ],
            [],
            [],
            [
                null,
                null,
                null,
                null,
                { id: 1, numero: 1, tooltip: 'F3:B9' },
                { id: 2, numero: 2 },
                { id: 3, numero: '3', tooltip: 'F3:B5' },
                { id: 4, numero: '4', tooltip: 'F3:B3' },
                { id: 5, numero: 5, tooltip: 'F3:B1' },
                null,
                null,
                null,
                { id: 7, numero: 7, tooltip: 'F3:B2', offset: 0 },
                { id: 8, numero: 8, tooltip: 'F3:B4' },
                { id: 9, numero: '9', tooltip: 'F3:B6' },
                { id: 10, numero: '10', tooltip: 'F3:B8' },
                { id: 11, numero: 11, tooltip: 'F3:B10' },
                null,
                null,
                null,
            ],
            [
                null,
                null,
                null,
                null,
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 10 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                null,
            ],
            [
                null,
                null,
                null,
                null,
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 20 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                null,
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 30 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 13, numero: 13 },
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 40 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 13, numero: 13 },
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 50 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 13, numero: 13 },
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 60 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 13, numero: 13 },
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3' },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 70 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 13, numero: 13 },
            ],
            [
                { id: 1, numero: 1 },
                { id: 2, numero: 2 },
                null,
                null,
                { id: 3, numero: '3', },
                { id: 4, numero: '4' },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                { id: 5, numero: 5 },
                null,
                null,
                null,
                { id: 7, numero: 7, offset: 80 },
                { id: 8, numero: 8 },
                { id: 9, numero: '9' },
                { id: 10, numero: '10' },
                { id: 11, numero: 11 },
                null,
                null,
                { id: 13, numero: 13 },
                { id: 14, numero: 14 },
            ],
        ];
        var loading = this.state.loading;
        return (React.createElement("div", null,
            React.createElement("h1", null, "Anfiteatro"),
            React.createElement("div", { style: { marginTop: '10px' } },
                React.createElement(Seatmap
                // addSeatCallback={this.addSeatCallback}
                // removeSeatCallback={this.removeSeatCallback}
                , { 
                    // addSeatCallback={this.addSeatCallback}
                    // removeSeatCallback={this.removeSeatCallback}
                    rows: anfiteatro, offsets: [0, 0, 0, 0], maxReservableSeats: 50, alpha: true, visible: true, selectedByDefault: true, loading: loading, tooltipProps: { multiline: true } })),
            React.createElement("div", { style: { marginTop: '100px' } }),
            React.createElement("h1", null, "Patio Butacas"),
            React.createElement("div", { style: { marginTop: '10px' } },
                React.createElement(Seatmap
                // @ts-ignore
                , { 
                    // @ts-ignore
                    addSeatCallback: this.addSeatCallbackContinousCase, removeSeatCallback: this.removeSeatCallback, rows: patio, offsets: [40, 40, 0, 0, 40, 35, 30, 25, 20, 15, 10, 5, 0], maxReservableSeats: 50, 
                    // alpha
                    // visible
                    // showNumber
                    selectedByDefault: true, loading: loading, tooltipProps: { multiline: true } }))));
    };
    return SeatPickerImp;
}(Component));
export default SeatPickerImp;



//////////////////
// WEBPACK FOOTER
// ./src/components/SeatPickerImp.tsx
// module id = 1279
// module chunks = 0